import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Paper,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useState } from 'react';

const ReportTable = ({ reports }) => {
  const [locationFilter, setLocationFilter] = useState('');

  const filteredReports = locationFilter
    ? reports.filter((report) => report.location === locationFilter)
    : reports;

  const uniqueLocations = [...new Set(reports.map((r) => r.location))];

  return (
    <Box
      component={Paper}
      elevation={4}
      sx={{
        borderRadius: 4,
        p: 4,
        background: 'linear-gradient(145deg, #e3f2fd, #ffffff)',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography
        variant="h5"
        className="text-blue-700 font-bold"
        style={{ marginBottom: '20px', fontWeight: '400' }}
      >
        Submitted Reports Overview
      </Typography>

        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Filter by Location</InputLabel>
          <Select
            value={locationFilter}
            onChange={(e) => setLocationFilter(e.target.value)}
            label="Filter by Location"
          >
            <MenuItem value="">All Locations</MenuItem>
            {uniqueLocations.map((loc) => (
              <MenuItem key={loc} value={loc}>
                {loc}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Table sx={{ minWidth: 650, borderRadius: 2 }} aria-label="reports table">
        <TableHead sx={{ backgroundColor: '#1976d2' }}>
          <TableRow>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Date</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Location</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Vehicle</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Employees</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Usage</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Link</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {filteredReports.length > 0 ? (
            filteredReports.map((report, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: index % 2 === 0 ? '#f1f8ff' : 'white',
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell>{report.date}</TableCell>
                <TableCell>{report.location}</TableCell>
                <TableCell>
                  {report.vehicle.name} ({report.vehicle.capacity} seater)
                </TableCell>
                <TableCell>
                  {report.presentEmployees.length > 0
                    ? report.presentEmployees.join(', ')
                    : 'None'}
                </TableCell>
                <TableCell>{report.usage || '-'}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    href={`/report/${report.reportId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Report
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No reports found for this location.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ReportTable;
